import { Injectable } from '@angular/core';

import { ApiStore, SearchType, SuperType } from '@fry/lib/store';
import { APIService } from '@fry/lib/api';

import { Dashboard, DashboardDoc, DashboardType } from '@fry/dashboards/lib';
import { Observable, map } from 'rxjs';

const DEFAULT_DASHBOARD: DashboardDoc = {
  "_id": "default",
  "type": "dashboard",
  "name": "Default Dashboard",
  "roles": [],
  "usedFor": ["dashboard", "summary"],
  "board": {
    "columns": [
      {
        "id": "column-1",
        "title": "Column 1",
        "cards": [
          {
            "id": "profile",
            "type": "profile",
            "options": {
            }
          },
          {
            "id": "user-available",
            "type": "user-available",
            "options": {
              "title": "Available bookings",
            }
          }
        ],
      },
      {
        "id": "column-2",
        "title": "Column 2",
        "cards": [
          {
            "id": "booking-table",
            "type": "booking-table",
            "options": {
              "title": "My recent bookings",
              "searchModel": {
                "filter": {
                  "user": "__context__user"
                },
                "sort": {
                  "sort_on": "createdDate",
                  "sort_order": "desc"
                },
                "select": [
                  "bookingItem",
                  "bookingOption",
                  "modifiedDate",
                  "stateName",
                  "view"
                ],
                "options": {
                  "includeFormFields": false
                }
              }
            }
          }
        ]
      }
    ]
  }
}

@Injectable({
  providedIn: 'root'
})
export class DashboardsStore extends ApiStore<Dashboard, DashboardDoc> {
  AssociatedModel = Dashboard;

  docType = 'dashboard';
  endpoint = 'dashboards';
  superType = SuperType.Org;
  searchType = SearchType.LOCAL;

  constructor(api: APIService) {
    super(api);
  }

  public blank(defaults?: Partial<DashboardDoc>) {
    const doc = this.prepareBlank(defaults) as DashboardDoc;
    return this.createObject({
      ...doc,
      board: {
        columns: [
          {
            "id": "column-1",
            "title": "Column 1",
            "cards": []
          },
          {
            "id": "column-2",
            "title": "Column 2",
            "cards": []
          }
        ]
      },
      roles: [],
    });
  };

  public getDefaultDashboard(): Dashboard {
    const dashboard = JSON.parse(JSON.stringify(DEFAULT_DASHBOARD));
    return this.createObject(dashboard);
  }

  public getAvailableDashboards(roles: string[], dashboardType: DashboardType): Observable<Dashboard[]> {
    return this.all().pipe(
      map(dashboards => {
        return dashboards.filter(dashboard => {
          const usedFor: DashboardType[] = dashboard.doc.usedFor || Dashboard.USED_FOR_DEFAULT;
          if (!usedFor.includes(dashboardType)) {
            return false;
          }

          const docRoles = Array.isArray(dashboard.doc.roles) ? dashboard.doc.roles : [];

          if (docRoles.includes('__all__')) {
            return true;
          }

          return docRoles.some(role => roles.includes(role));
        });
      })
    );
  }
}
